import "devextreme/data/odata/store";
import { locale as devExLocale, loadMessages } from "devextreme/localization";
import {
  Column,
  DataGrid,
  FilterRow,
  Pager,
  Paging,
  LoadPanel,
} from "devextreme-react/data-grid";

import React, { createRef, useEffect, useMemo, useRef, useState } from "react";
import elMessages from "devextreme/localization/messages/el.json";
import { useTranslation } from "react-i18next";

import CustomStore from "devextreme/data/custom_store";
import { makeStyles, useTheme } from "@mui/styles";
import themes from "devextreme/ui/themes";
import { Formik } from "formik";
import { Button, ButtonGroup, Grid, Tooltip } from "@mui/material";

import DateTimePicker from "../DateTime";
import Search from "../Search";
import * as dayjs from "dayjs";
import SecondaryButton from "../SecondaryButton";
import { useNavigate } from "react-router-dom";
import EditIcon from "../Icons/Edit";
import FileDownloadIcon from "../Icons/File";
import DeleteIcon from "../Icons/Delete";
import { useMutation } from "react-query";
import loading from "./halfCircle.gif";
import {
  BOOK_STATUS_CANCELLED,
  BOOK_STATUS_PUBLISHED,
} from "../../../constants/generalConstants";

// import 'devextreme/dist/css/dx.light.css';
const useStyles = makeStyles((theme) => {
  return {
    // container: {
    //   width: "100%",
    // },
    datagrid: {
      // width: "99%",

      "& .dx-data-row": {
        display: "span",
        borderTop: "11px solid transparent",
        borderBottom: "11px solid transparent",
        // display: "block",
        // boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
        // width: "100% !important",
        borderRadius: `${theme.shape.borderRadius}px !important`,
        // padding: "20px",
        // pageBreakInside: "avoid !important",
      },
    },
  };
});
loadMessages(elMessages);
const DataGrid2 = ({
  getAll,
  cols,
  toolbarOptions,
  editUrl,
  deleteRow,
  downloadAcsmFile,
  handleDownloadAcsmFile,
  handleDeleteBook,
  message,
  ...props
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const { t, locale } = useTranslation();
  const exportRequest = toolbarOptions.export.request;
  devExLocale(locale);
  const [pageSizes] = useState([5, 10, 15]);
  const dataGridRef = createRef();
  const formikRef = useRef();
  // const [actionColumnClick, setActionColumnClick] = useState(false);
  const { mutate } = useMutation(deleteRow, {
    onSuccess: (data) => {},
    onError: (error) => {},
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const store = useMemo(() => {
    return new CustomStore({
      key: "id",
      loadMode: "processed",
      useDefaultSearch: false,
      load: async (loadOptions) => {
        // created seach columns map
        const searchMap = [];
        if (loadOptions?.filter?.filterValue) {
          searchMap.push({
            col: loadOptions?.filter[0],
            value: loadOptions?.filter[2],
          });
        } else {
          loadOptions?.filter?.forEach((item, index) => {
            if (index % 2 === 0) {
              return searchMap.push({ col: item[0], value: item[2] });
            }
          });
        }
        const sortValue = loadOptions?.sort?.[0]?.selector;
        const sortType = loadOptions?.sort?.[0]?.desc === true ? "DESC" : "ASC";
        try {
          const data = await getAll(
            loadOptions.skip / loadOptions.take,
            loadOptions.take,
            sortValue,
            sortType,
            formikRef.current.values.column,
            formikRef.current.values.searchValue,
            formikRef.current.values.fromDate
              ? dayjs(formikRef.current.values.fromDate).format("YYYY-MM-DD")
              : null,
            formikRef.current.values.toDate
              ? dayjs(formikRef.current.values.toDate).format("YYYY-MM-DD")
              : null
          );
          if (data?.response?.status > 400) {
            return { currentPage: 0, totalCount: 0, totalPages: 0, data: [] };
          }
          return data;
        } catch (error) {
          return { currentPage: 0, totalCount: 0, totalPages: 0, data: [] };
        }
      },
    });
  });

  const exportAndDownload = async (
    searchCol,
    searchValue,
    fromDate,
    toDate
  ) => {
    try {
      const res = await exportRequest(
        searchCol,
        searchValue,
        fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : null,
        toDate ? dayjs(toDate).format("YYYY-MM-DD") : null
      );
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `export.csv`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const themeName = theme.name === "DARK" ? "DARK" : "LIGHT";
    themes.current(themeName);
  }, [theme.name]);

  const handleDownload = (id) => {
    handleDownloadAcsmFile(id);
  };

  return (
    <div className={styles.container}>
      <Formik
        innerRef={formikRef}
        initialValues={{
          fromDate: null,
          toDate: null,
          searchValue: "",
          column: "",
        }}
      >
        {({ values }) => (
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignItems={"center"}
            sx={{ marginTop: 10, marginBottom: 10 }}
          >
            <Grid
              container
              item
              direction="row"
              //justifyContent="space-between"
              alignItems={"center"}
              spacing={2}
            >
              <Grid item xs={"auto"}>
                <DateTimePicker />
              </Grid>

              <Grid item xs={2}>
                {toolbarOptions?.export?.show && (
                  <SecondaryButton
                    onClick={() =>
                      exportAndDownload(
                        values?.column,
                        values?.searchValue,
                        values?.fromDate,
                        values?.toDate
                      )
                    }
                  >
                    Export
                  </SecondaryButton>
                )}
              </Grid>
              <Grid item xs={4} />
              <Grid item container xs={"auto"}>
                <Search
                  items={cols?.map((col) => {
                    return { label: col?.caption, value: col?.dataField };
                  })}
                />
              </Grid>
            </Grid>
            <Grid
              container
              item
              direction="row"
              justifyContent="flex-end"
              alignItems={"center"}
            >
              <Grid item sx={{ marginTop: 4 }}>
                <Button
                  variant="outlined"
                  onClick={() => dataGridRef.current.instance.refresh()}
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
      <DataGrid
        columnHidingEnabled
        ref={dataGridRef}
        noDataText={t("No data to display")}
        {...props}
        dataSource={store || []}
        keyExpr="id"
        columnResizingMode="widget"
        columnAutoWidth={true}
        showBorders={false}
        showColumnLines={false}
        showRowLines={false}
        rowAlternationEnabled={false}
        allowColumnReordering={true}
        allowColumnResizing={true}
        remoteOperations={{ paging: true, filtering: true, sorting: true }}
        // onCellHoverChanged={(e) => {
        //   e.column.caption === "Action"
        //     ? setActionColumnClick(true)
        //     : setActionColumnClick(false);
        // }}
      >
        <LoadPanel
          height={150}
          width={300}
          indicatorSrc={loading}
          className="loadPanel"
          showPane={false}
          showIndicator={false}
        />

        {cols.map((col) => (
          <Column {...col} />
        ))}
        {/**Edit button */}
        {editUrl && (
          <Column
            width={130}
            key="edit"
            caption=""
            cellRender={(rowData) => (
              <ButtonGroup
                size="small"
                aria-label="small button group"
                variant="text"
              >
                <Tooltip placement="top" title="Edit">
                  <Button onClick={() => navigate(editUrl + rowData?.data?.id)}>
                    <EditIcon />
                  </Button>
                </Tooltip>
                {handleDownloadAcsmFile && (
                  <Tooltip
                    placement="top"
                    title={
                      rowData?.data.status !== BOOK_STATUS_PUBLISHED
                        ? "Please Upload Book"
                        : "Download ACSM"
                    }
                  >
                    <span>
                      <Button
                        disabled={
                          rowData?.data.status !== BOOK_STATUS_PUBLISHED
                        }
                        onClick={() => {
                          handleDownload(rowData?.data?.id);
                        }}
                      >
                        <FileDownloadIcon
                          // color={}
                          styleColor={`${
                            rowData?.data.status !== BOOK_STATUS_PUBLISHED
                              ? ""
                              : "#6fc0ff"
                          }`}
                        />
                      </Button>
                    </span>
                  </Tooltip>
                )}
                {handleDeleteBook && (
                  <Tooltip placement="top" title={"Delete book"}>
                    <Button
                      disabled={rowData?.data.status === BOOK_STATUS_CANCELLED}
                      onClick={() => {
                        handleDeleteBook(
                          rowData?.data?.id,
                          rowData?.data?.title
                        );
                      }}
                    >
                      <DeleteIcon />
                    </Button>
                  </Tooltip>
                )}
              </ButtonGroup>
            )}
          />
        )}
        {/**Download acsm button */}
        {/* {handleDownloadAcsmFile && (
          <Column
            width={80}
            key="download"
            caption="Action"
            cellRender={(rowData) => (
              <>
                <Tooltip
                  placement="top"
                  title={
                    rowData?.data.status !== BOOK_STATUS_PUBLISHED
                      ? "Please Upload Book"
                      : "Download ACSM"
                  }
                >
                  <span>
                    <Button
                      disabled={rowData?.data.status !== BOOK_STATUS_PUBLISHED}
                      onClick={() => {
                        handleDownload(rowData?.data?.id);
                      }}
                    >
                      <FileDownloadIcon
                        // color={}
                        styleColor={`${
                          rowData?.data.status !== BOOK_STATUS_PUBLISHED
                            ? ""
                            : "#6fc0ff"
                        }`}
                      />
                    </Button>
                  </span>
                </Tooltip>
              </>
            )}
          />
        )} */}
        {/**Delete book button */}
        {/* {handleDeleteBook && (
          <Column
            width={80}
            key="download"
            caption="Delete"
            cellRender={(rowData) => (
              <>
                <Tooltip placement="top" title={"Delete book"}>
                  <span>
                    <Button
                      disabled={rowData?.data.status === BOOK_STATUS_CANCELLED}
                      onClick={() => {
                        handleDeleteBook(
                          rowData?.data?.id,
                          rowData?.data?.title
                        );
                      }}
                    >
                      <DeleteIcon />
                    </Button>
                  </span>
                </Tooltip>
              </>
            )}
          />
        )} */}
        {/**Delete button */}
        {deleteRow && (
          <Column
            width={80}
            key="delete"
            caption="Delete"
            cellRender={(rowData) => (
              <Button onClick={() => mutate(rowData?.data?.id)}>
                <DeleteIcon />
              </Button>
            )}
          />
        )}
        {/* <Editing
          refreshMode={"reshape"}
          mode="popup"
          // allowAdding={true}
          // allowDeleting={true}
          allowUpdating={true}
        /> */}
        <Pager
          displayMode={"full"}
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={pageSizes}
          showNavigationButtons={true}
        />
        <Paging defaultPageSize={5} />
        <FilterRow visible={false} showOperationChooser={false} />
        {/* <SearchPanel visible={true} /> */}
      </DataGrid>
    </div>
  );
};

export default DataGrid2;
